import { TipoDestinoEnum } from "core/features/documentos/enums";
import { ControllerRenderProps } from "react-hook-form";
import SelectGrupoUnidade from "ui/components/Input/SelectGrupoUnidade";
import { Input, InputGroup, InputRightElement, Flex } from "@chakra-ui/react";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import SelectPerfil from "components/Input/SelectPerfil";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import colors from "core/resources/theme/colors";

interface RenderSelectEntidadeProps {
  tenantId: string;
  tipoDestinoId: TipoDestinoEnum;
  field: ControllerRenderProps<any, any>;
  isInvalid: boolean | undefined;
  showValue?: boolean;
  selectSize?: "large" | "small";
  inputSize?: "sm" | "md" | "lg" | "xs";
  onChangeGrupo: (v: any, option: any) => any;
  onChangePessoa?: (v: any, option: any) => any;
  onChangeUnidade: (v: any, option: any) => any;
  onChangeCargo?: (v: any, option: any) => any;
  onSubmitEmail?: (v: string) => any;
  tiposPessoa?: TipoEntidadeEnum[];
  filteredOptions?: string[];
  unidadeSelectGruposUnidadesIds?: string[];
}
function RenderSelectEntidade({
  tenantId,
  field,
  isInvalid,
  onChangeCargo,
  onChangeGrupo,
  onChangePessoa,
  onChangeUnidade,
  tipoDestinoId,
  inputSize,
  selectSize,
  showValue,
  onSubmitEmail,
  tiposPessoa,
  filteredOptions,
  unidadeSelectGruposUnidadesIds,
}: RenderSelectEntidadeProps) {
  return (
    <>
      {tipoDestinoId === TipoDestinoEnum.UmGrupoUnidades ? (
        <SelectGrupoUnidade
          onChange={onChangeGrupo}
          labelInValue={false}
          isInvalid={isInvalid}
          value={showValue ? field.value : []}
          size={selectSize}
          filteredOptions={filteredOptions}
        />
      ) : null}
      {tipoDestinoId === TipoDestinoEnum.Email ? (
        <InputGroup>
          <Input
            onChange={(ev) => {
              const val = ev.target.value
                .replace(/^\s{1,}/, "")
                .replace(/\s{2,}/g, " ");
              field.onChange(val);
            }}
            value={field.value}
            size={inputSize}
            placeholder="Email"
            onKeyUp={
              onSubmitEmail
                ? (ev) => {
                    if (ev.key === "Enter") {
                      onSubmitEmail?.(field.value);
                    }
                  }
                : undefined
            }
          />
          {onSubmitEmail ? (
            <InputRightElement>
              <Flex
                borderLeftWidth={1}
                h="100%"
                px="6px"
                mr="-6px"
                alignItems="center"
                roundedRight="6px"
                borderLeftColor={colors.borderGray}
                cursor="pointer"
                onClick={() => onSubmitEmail?.(field.value)}
                _hover={{
                  bg: colors.primary,
                  color: colors.white,
                  borderLeftColor: colors.primary,
                }}
              >
                Ok
              </Flex>
            </InputRightElement>
          ) : null}
        </InputGroup>
      ) : null}
      {tipoDestinoId === TipoDestinoEnum.UmaUnidade ? (
        <SelectUnidade
          tenantId={tenantId}
          onChange={onChangeUnidade}
          isInvalid={isInvalid}
          value={showValue ? field.value : []}
          size={selectSize}
          filteredOptions={filteredOptions}
          gruposUnidadesIds={unidadeSelectGruposUnidadesIds}
        />
      ) : null}
      {tipoDestinoId === TipoDestinoEnum.UmaPessoa ? (
        <SelectPessoas
          tenantId={tenantId}
          onChange={onChangePessoa}
          isInvalid={isInvalid}
          value={showValue ? field.value : []}
          size={selectSize}
          tipoEntidades={tiposPessoa}
          filteredOptions={filteredOptions}
        />
      ) : null}
      {tipoDestinoId === TipoDestinoEnum.UmCargo ? (
        <SelectPerfil
          tenantId={tenantId}
          onChange={onChangeCargo}
          isInvalid={isInvalid}
          value={showValue ? field.value : []}
          size={selectSize}
          placeholder="Selecione um"
          mode={undefined}
          filteredOptions={filteredOptions}
        />
      ) : null}
    </>
  );
}

export default RenderSelectEntidade;
